import { useContext } from 'react';
import { EditPayoutProfileDrawerContext } from './EditPayoutProfileDrawerContext';

export const useEditPayoutProfileDrawer = () => useContext(EditPayoutProfileDrawerContext);
